import { render } from "./SaveIconNew.vue?vue&type=template&id=51921ff0"
import script from "./SaveIconNew.vue?vue&type=script&lang=js"
export * from "./SaveIconNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__